import type { DocumentNode } from 'graphql';
import { Requests } from './requests';
import { getOperationName } from './getOperationName';

export const getQueryByOperationName = (
  operationName: string,
): DocumentNode | null => {
  for (const regexp of Object.keys(Requests)) {
    const definitions = Requests[regexp];
    const query = definitions.find(
      (definition) => getOperationName(definition.query) === operationName,
    )?.query;
    if (query) {
      return query;
    }
  }

  return null;
};
